module.exports = __webpack_public_path__ + "static/media/premium-cup-logo.eb41cec7.svg";